// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes MobileTabletHelp_appear__9n6YX {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes MobileTabletHelp_appearTablet__rDTVN {
    from {
        opacity: 0;
        transform: translateY(20px) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
    }
}

.MobileTabletHelp_container__RwP5u {
    position: fixed;
    max-width: 20%;
    background-color: #111018;
    color: #fff;
    padding: 32px 32px;
    z-index: 2000;
    animation: MobileTabletHelp_appear__9n6YX 0.5s ease-out;
    overflow-y: auto;
}

.MobileTabletHelp_closeButton__EF-LY {
    position: absolute;
    top: 1%;
    right: 3%;
    border: none;
    background-color: #ffffff20;
    border-radius: 50%;
    aspect-ratio: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MobileTabletHelp_header__lHbNL {
    margin-top: 8%;
    display: flex;
    gap: 12px;
    align-items: center;
}

.MobileTabletHelp_title__oTlT8 {
    font-size: var(--font-size-11);
}

.MobileTabletHelp_description__lmq0p {
    font-size: var(--font-size-6);
    line-height: 24px;
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletHelp_faq__puSrs {
    margin-top: 32px;
}

@media (max-width: 767px) {
    .MobileTabletHelp_container__RwP5u {
        right: 0;
        left: 0;
        bottom: 0;
        top: 0;
        max-width: 100%;
        padding: 16px 32px;
        border-radius: 0px;
    }

    .MobileTabletHelp_header__lHbNL {
        margin-top: 6%;
    }

    .MobileTabletHelp_closeButton__EF-LY {
        top: 4.5%;
    }

    .MobileTabletHelp_title__oTlT8 {
        font-size: var(--font-size-11);
        font-family: var(--font-semi-bold), sans-serif;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .MobileTabletHelp_container__RwP5u {
        padding: 16px 24px;
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        max-width: none;
        border-radius: 16px;
        top: unset;
        animation: MobileTabletHelp_appearTablet__rDTVN 0.5s ease-out;
        overflow: scroll;
        max-height: 80%;
    }

    .MobileTabletHelp_header__lHbNL {
        margin-top: 2%;
    }
}

@media (min-width: 1024px) {
    .MobileTabletHelp_container__RwP5u {
        padding: 8px 24px;
        bottom: 12%;
        left: 50%;
        transform: translateX(-50%);
        width: 68%;
        max-width: none;
        border-radius: 16px;
        height: auto;
        max-height: 80%;
        top: unset;
        overflow: scroll;
        animation: MobileTabletHelp_appearTablet__rDTVN 0.5s ease-out;
    }

    .MobileTabletHelp_header__lHbNL {
        margin-top: 2%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/MobileTabletHelp/MobileTabletHelp.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uDAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,SAAS;QACT,MAAM;QACN,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,8BAA8B;QAC9B,8CAA8C;IAClD;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,UAAU;QACV,6DAAqC;QACrC,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,UAAU;QACV,gBAAgB;QAChB,6DAAqC;IACzC;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes appearTablet {\n    from {\n        opacity: 0;\n        transform: translateY(20px) translateX(-50%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) translateX(-50%);\n    }\n}\n\n.container {\n    position: fixed;\n    max-width: 20%;\n    background-color: #111018;\n    color: #fff;\n    padding: 32px 32px;\n    z-index: 2000;\n    animation: appear 0.5s ease-out;\n    overflow-y: auto;\n}\n\n.closeButton {\n    position: absolute;\n    top: 1%;\n    right: 3%;\n    border: none;\n    background-color: #ffffff20;\n    border-radius: 50%;\n    aspect-ratio: 1;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.header {\n    margin-top: 8%;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.title {\n    font-size: var(--font-size-11);\n}\n\n.description {\n    font-size: var(--font-size-6);\n    line-height: 24px;\n    font-family: var(--font-medium), sans-serif;\n}\n\n.faq {\n    margin-top: 32px;\n}\n\n@media (max-width: 767px) {\n    .container {\n        right: 0;\n        left: 0;\n        bottom: 0;\n        top: 0;\n        max-width: 100%;\n        padding: 16px 32px;\n        border-radius: 0px;\n    }\n\n    .header {\n        margin-top: 6%;\n    }\n\n    .closeButton {\n        top: 4.5%;\n    }\n\n    .title {\n        font-size: var(--font-size-11);\n        font-family: var(--font-semi-bold), sans-serif;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .container {\n        padding: 16px 24px;\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 95%;\n        max-width: none;\n        border-radius: 16px;\n        top: unset;\n        animation: appearTablet 0.5s ease-out;\n        overflow: scroll;\n        max-height: 80%;\n    }\n\n    .header {\n        margin-top: 2%;\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        padding: 8px 24px;\n        bottom: 12%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 68%;\n        max-width: none;\n        border-radius: 16px;\n        height: auto;\n        max-height: 80%;\n        top: unset;\n        overflow: scroll;\n        animation: appearTablet 0.5s ease-out;\n    }\n\n    .header {\n        margin-top: 2%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletHelp_container__RwP5u`,
	"appear": `MobileTabletHelp_appear__9n6YX`,
	"closeButton": `MobileTabletHelp_closeButton__EF-LY`,
	"header": `MobileTabletHelp_header__lHbNL`,
	"title": `MobileTabletHelp_title__oTlT8`,
	"description": `MobileTabletHelp_description__lmq0p`,
	"faq": `MobileTabletHelp_faq__puSrs`,
	"appearTablet": `MobileTabletHelp_appearTablet__rDTVN`
};
export default ___CSS_LOADER_EXPORT___;
